<template>
	<div class="content">
		<div class="top">
			<img :src="'/'+global.logo+'/logo.png'" alt="">
			<div class="tabs">
				<span :class="{active:0==activeName}" @click="handleClick(0)">首页</span>
				<span class="down" :class="{active:12==activeName||11==activeName}">解决方案
					<div class="dropdownUl">
						<div class="li" @click="handleClick(11)">仓储解决方案</div>
						<div class="li" @click="handleClick(12)">供应链解决方案</div>
					</div>
				</span>
				<span :class="{active:2==activeName}" @click="handleClick(2)">运营学院</span>
				<span :class="{active:3==activeName}" @click="handleClick(3)">渠道合作</span>
				<span :class="{active:4==activeName}" @click="handleClick(4)">关于{{global.normalName}}</span>
				<span class="down" v-if="global.od_id==='1'">app下载
					<div class="dropdownUl">
						<div class="li" @click="down(1)"><img src="./assets/icon_anzuo.png" alt="">安卓</div>
						<div class="li" @click="down(2)"><img src="./assets/icon_ios.png" alt="">ios</div>
						<div class="li" @click="down(3)"><img src="./assets/icon_wei.png" alt="">小程序</div>
					</div>
				</span>
				<span class="down" @click="down(3)" v-else>小程序</span>
			</div>
		</div>
		<div class="tab-content">
			<keep-alive>
				<component :is="curTabcompnents[activeName]"></component>
			</keep-alive>
		</div>
		<div class="alert" v-if="alert==2">
			<div class="mask" @click="close"></div>
			<div class="box">
				<i class="el-icon-circle-close" @click="close"></i>
				<img :src="'/'+global.logo+'/ios.png'" alt="">
				<p>请扫描下方二维码下载ios应用</p>
			</div>
		</div>
		<div class="alert" v-if="alert==1">
			<div class="mask" @click="close"></div>
			<div class="box">
				<i class="el-icon-circle-close" @click="close"></i>
				<img :src="'/'+global.logo+'/anzhuo.jpg'" alt="">
				<p>请扫描下方二维码下载安卓应用</p>
			</div>
		</div>
		<div class="alert" v-if="alert==3">
			<div class="mask" @click="close"></div>
			<div class="box">
				<i class="el-icon-circle-close" @click="close"></i>
				<img :src="'/'+global.logo+'/wechat.jpg'" alt="">
				<p>请扫描下方二维码进入小程序</p>
			</div>
		</div>
	</div>
</template>

<script>
	import Index from './index.vue' //商品列表
	import ChannelCooperation from './ChannelCooperation.vue' //渠道合作
	import About from './About.vue' //关于国免
	import operationCollege from './operationCollege.vue' //运营学院
	import nationalSolutions from './nationalSolutions.vue' //国免仓解决方案
	import supplySolutions from './supplySolutions.vue' //供应链解决方案
	export default {
		data() {
			return {
				tab: ['首页', '解决方案', '经典案例', '渠道合作', '关于'+this.global.normalName],
				activeName: '0',
				curTabcompnents: {
					'0': 'Index',
					'11': 'nationalSolutions',
					'12': 'supplySolutions',
					'2': 'operationCollege',
					'3': 'ChannelCooperation',
					'4': 'About',
				},
				alert: 0,
			}
		},
		components: {
			Index,
			ChannelCooperation,
			About,
			operationCollege,
			nationalSolutions,
			supplySolutions,
		},
		mounted() {
			console.log(this.global);
		},
		methods: {
			handleClick(tab) {
				console.log(tab)
				this.activeName = tab;
			},
			close: function() {
				this.alert = 0
			},
			down:function(index){
				this.alert = index
			}
		},
	}
</script>

<style scoped>
	.content {
		width: 100%;
		margin: 0 auto;
	}

	.top {
		width: 60%;
		display: flex;
		justify-content: space-between;
		align-items: center;
		position: sticky;
		top: 37px;
		background: #fff;
		padding: 0 20%;
		z-index: 999;
	}

	.top img {
		height: 80px;
		margin: 10px 0;
	}

	.tabs {
		display: flex;
		position: relative;
		cursor: pointer;
	}

	.tabs span {
		display: block ruby;
		padding: 5px 35px;
		border-right: 1px solid #E1E1E1;
		position: relative;
	}

	.tabs span.active {
		color: #DA4831;
	}

	.tabs span.active::after {
		content: "";
		display: block;
		width: 90%;
		height: 3px;
		background: #DA4831;
		position: absolute;
		left: 5%;
		bottom: -35px;
	}

	.down:hover .dropdownUl {
		opacity: 1;
	}

	.dropdownUl {
		position: absolute;
		top: 30px;
		background: #fff;
		box-shadow: 0 2px 4px rgba(0, 0, 0, 0.4);
		left: 0%;
		opacity: 0;
		font-size: 14px;
		z-index: 9;
		width: 100%;
		min-width: 100px;
	}

	.dropdownUl .li {
		padding: 15px;
		border-bottom: 1px solid #f4f4f4;
		color: #333;
		display: flex;
		align-items: center;
	}
	.dropdownUl .li img{
		width: 25px;
		height: auto;
		margin: 0;
	}
	.tab-content {
		width: 100%;
	}

	@media screen and (max-width: 1600PX) {
		.top {
			width: 80%;
			padding: 0 10%;
		}
	}

	.alert {
		width: 100%;
		height: 100%;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 999;
	}

	.alert .mask {
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.5);
	}

	.alert .box {
		background: #fff;
		width: 350px;
		height: 350px;
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		border-radius: 10px;
		text-align: center;
	}

	.alert .el-icon-circle-close {
		position: absolute;
		top: 3%;
		right: 3%;
		font-size: 30px;
		color: #666;
	}

	.alert img {
		width: 80%;
		height: 80%;
		margin: 10% auto 0;
	}
</style>
